import FromToFilterComponent from '@/components/global/filters/FromToFilterComponent.jsx';
import { ReferenceArrayFilter } from '@/components/global/filters/filters.jsx';
import { SearchBar } from '@/components/global/list/searchBar.jsx';

export const RETAIL_CHAIN_SEARCH_FIELDS = {
    name: true,
    'brands.name': true,
};

export const getRetailChainFilters = (isMobile, translate) => [
    <SearchBar key='search' source='value' fields={RETAIL_CHAIN_SEARCH_FIELDS} label={translate('common.search')} alwaysOn />,
    <ReferenceArrayFilter
        key='brands'
        source='brands->id_in'
        reference='brand'
        label={translate('resources.retailChain.filters.brand')}
        searchFields={['name']}
        perPage={1000}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
    <FromToFilterComponent
        key='contractorCount'
        source='contractorCount_range'
        label={translate('resources.retailChain.filters.contractorCount')}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
    <FromToFilterComponent
        key='collectionPointCount'
        source='collectionPointCount_range'
        label={translate('resources.retailChain.filters.collectionPointCount')}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
];
